// extracted by mini-css-extract-plugin
var _1 = "ra-art-details-comment-no-author";
var _2 = "ra-art-details-gallery";
var _3 = "ra-art-details-gallery-wrapper";
var _4 = "ra-art-details-tab-section-heading-with-link";
var _5 = "ra-art-details-same-artist";
var _6 = "ra-art-details-scrollmarker";
var _7 = "ra-art-details-scrollmarker-wrapper";
var _8 = "ra-art-details-section-breadcrumbs";
var _9 = "ra-art-details-section-narrow";
var _a = "ra-art-details-similar";
var _b = "ra-art-details-tab-section";
var _c = "ra-art-details-urgent-message";
export { _1 as "artDetailsCommentNoAuthorCls", _2 as "artDetailsGalleryCls", _3 as "artDetailsGalleryWrapperCls", _4 as "artDetailsHeadingWithLinkCls", _5 as "artDetailsSameArtistCls", _6 as "artDetailsScrollMarkerCls", _7 as "artDetailsScrollMarkerWrapperCls", _8 as "artDetailsSectionBreadcrumbsCls", _9 as "artDetailsSectionNarrowCls", _a as "artDetailsSimilarCls", _b as "artDetailsTabSectionsCls", _c as "artDetailsUrgentMessageCls" }
